import licenseModule from '../../license.module';
import style from './licensePlanInfoSummary.component.css';

licenseModule.component('licensePlanInfoSummary', {
    template: require('./licensePlanInfoSummary.component.html'),
    style,
    controller: [
        'asLoadingMask',
        'LicenseManagementService',
        'entitlementConstants',
        licensePlanInfoSummaryComponent
    ],
    bindToController: true,
    bindings: {
        planInfoSummary: '<'
    }
});

function licensePlanInfoSummaryComponent(
    asLoadingMask,
    LicenseManagementService,
    entitlementConstants
) {
    var vm = this;
    vm.devicesLabel = entitlementConstants.devices;
    vm.platformUsersLabel = entitlementConstants.platformUsers;

    vm.$onChanges = change;
    asLoadingMask.show();

    function calculateTotalStorageGB() {
        // get the Appspace ID information
        LicenseManagementService.getAppspaceIDSummary().then(
            function(data) {
                vm.appspaceIdSummary = data;

                asLoadingMask.hide();
            },
            function() {
                // handle error
            }
        );

        if (vm.planInfoSummary != null && vm.planInfoSummary.endDate != null) {
            vm.showEndDate = true;
        } else {
            vm.showEndDate = false;
        }
    }

    function getFlagMessage() {
        var endDate = vm.planInfoSummary.endDate;
        var today = new Date();

        if (endDate == null) {
            return null;
        } else {
            var todayTime = today.getTime();
            var endTime = endDate.getTime();
            var timeDiff = Math.abs(todayTime - endTime);
        }

        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        var wordDays = 'day';

        if (diffDays > 1) {
            wordDays = 'days';
        }

        if (vm.planInfoSummary.planStatus == 'warning') {
            vm.showFlag = true;
            vm.flagMessage =
                'Your subscription will expire in ' +
                diffDays +
                ' ' +
                wordDays +
                '. At that time your devices will stop receiving content updates. Please contact Appspace to renew your subscription.';
            vm.alertClass = 'alertWarning';
            vm.alertLabel = 'Expiring';
        } else if (vm.planInfoSummary.planStatus == 'inactive') {
            vm.showFlag = true;
            vm.flagMessage =
                'Your subscription has expired. Please contact Appspace to renew your subscription.';
            vm.alertClass = 'alertInactive';
            vm.alertLabel = 'Expired';
        } else if (vm.planInfoSummary.planStatus == 'restricted') {
            vm.showFlag = true;
            vm.flagMessage =
                'Your subscription has expired. Your devices are no longer receiving content updates. Please contact Appspace to renew your subscription.';
            vm.alertClass = 'alertRestricted';
            vm.alertLabel = 'Expired';
        } else {
            vm.showFlag = false;
        }
    }

    function change(changeObj) {
        if (
            changeObj.planInfoSummary.currentValue &&
            changeObj.planInfoSummary.currentValue != null
        ) {
            calculateTotalStorageGB();
            getFlagMessage();
        }
    }
}



// WEBPACK FOOTER //
// ./modules/license/features/license-plan-info-summary/licensePlanInfoSummary.component.js